import { ComponentProps } from 'react';

export function UnreadIcon(props: ComponentProps<'svg'>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.12"
        d="M2.5 7.33334C2.5 5.93321 2.5 5.23315 2.77248 4.69837C3.01217 4.22796 3.39462 3.84551 3.86502 3.60583C4.3998 3.33334 5.09987 3.33334 6.5 3.33334H13.5C14.9001 3.33334 15.6002 3.33334 16.135 3.60583C16.6054 3.84551 16.9878 4.22796 17.2275 4.69837C17.5 5.23315 17.5 5.93321 17.5 7.33334V8.33334H2.5V7.33334Z"
        fill="currentColor"
      />
      <path
        d="M17.5 9.58332V7.33332C17.5 5.93319 17.5 5.23313 17.2275 4.69835C16.9878 4.22794 16.6054 3.84549 16.135 3.60581C15.6002 3.33332 14.9001 3.33332 13.5 3.33332H6.5C5.09987 3.33332 4.3998 3.33332 3.86502 3.60581C3.39462 3.84549 3.01217 4.22794 2.77248 4.69835C2.5 5.23313 2.5 5.93319 2.5 7.33332V14.3333C2.5 15.7335 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0608C4.3998 18.3333 5.09987 18.3333 6.5 18.3333H10.4167M17.5 8.33332H2.5M13.3333 1.66666V4.99999M6.66667 1.66666V4.99999"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7674 16.3033L15.5352 14.5355M15.5352 14.5355L17.3029 12.7678M15.5352 14.5355L13.7674 12.7678M15.5352 14.5355L17.3029 16.3033"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
